import Vue from 'vue'
import { userLogin, userGetInfo, userLogout } from '@/api/userAccount'
import {
  teacherLogin,
  teacherGetInfo,
  teacherLogout
} from '@/api/teacherAccount'
import { ACCESS_TOKEN, ACCOUNT_TYPE } from '@/store/mutation-types'
import { welcome } from '@/utils/util'

const account = {
  state: {
    token: '',
    name: '',
    welcome: '',
    avatar: '',
    type: '',
    roles: [],
    info: {}
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, { name, welcome }) => {
      state.name = name
      state.welcome = welcome
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_INFO: (state, info) => {
      state.info = info
    },
    SET_TYPE: (state, type) => {
      state.type = type
      Vue.ls.set(ACCOUNT_TYPE, type, 2 * 60 * 60 * 1000)
    }
  },
  actions: {
    // 用户登录
    UserLogin({ commit }, data) {
      return new Promise((resolve, reject) => {
        userLogin(data).then((response) => {
          if (response.status === 'success') {
            const userInfo = response.data.user_info
            commit('SET_NAME', { name: userInfo.nick_name, welcome: welcome() })
            commit('SET_AVATAR', userInfo.avatar)
            commit('SET_TYPE', response.data.user_type)
            resolve(response)
          } else {
            reject(response)
          }
        })
      })
    },

    // 获取用户信息
    UserGetInfo({ commit }) {
      return new Promise((resolve, reject) => {
        userGetInfo()
          .then((response) => {
            const data = response.data
            if (response.status === 'success') {
              commit('SET_TYPE', data.user_type)
              commit('SET_INFO', data.user_info)
              commit('SET_NAME', {
                name: data.user_info.nick_name,
                welcome: welcome()
              })
              commit('SET_AVATAR', data.user_info.avatar)
            } else {
              reject(new Error('getInfo: roles must be a non-null array !'))
            }
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    // 登出
    UserLogout({ commit }) {
      return new Promise((resolve) => {
        userLogout()
          .then(() => {
            resolve()
          })
          .catch(() => {
            resolve()
          })
          .finally(() => {
            commit('SET_TOKEN', '')
            commit('SET_ROLES', [])
            Vue.ls.remove(ACCESS_TOKEN)
          })
      })
    },

    // 教员登录
    TeacherLogin({ commit }, data) {
      return new Promise((resolve, reject) => {
        teacherLogin(data).then((response) => {
          if (response.status === 'success') {
            const teacherInfo = response.data.teacher_info
            commit('SET_NAME', {
              name: teacherInfo.nick_name,
              welcome: welcome()
            })
            commit('SET_AVATAR', teacherInfo.avatar)
            commit('SET_TYPE', response.data.user_type)
            resolve(response)
          } else {
            reject(response)
          }
        })
      })
    },

    // 获取教员信息
    TeacherGetInfo({ commit }) {
      return new Promise((resolve, reject) => {
        teacherGetInfo()
          .then((response) => {
            const data = response.data
            if (response.status === 'success') {
              commit('SET_TYPE', data.user_type)
              commit('SET_INFO', data.teacher_info)
              commit('SET_NAME', {
                name: data.teacher_info.nick_name,
                welcome: welcome()
              })
              commit('SET_AVATAR', data.teacher_info.avatar)
            } else {
              reject(new Error('getInfo: roles must be a non-null array !'))
            }
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    // 教员登出
    TeacherLogout({ commit }) {
      return new Promise((resolve) => {
        teacherLogout()
          .then(() => {
            resolve()
          })
          .catch(() => {
            resolve()
          })
          .finally(() => {
            commit('SET_TOKEN', '')
            commit('SET_ROLES', [])
            Vue.ls.remove(ACCESS_TOKEN)
          })
      })
    }
  }
}

export default account
